import React, {useEffect} from "react";
const Invoices = ()=> {
       useEffect(() => {
                const scriptUrls = [
                  "assets/js/jquery-3.7.1.min.js",
                  "assets/js/bootstrap.bundle.min.js",
                  "assets/plugins/select2/js/select2.min.js",
                  "assets/plugins/theia-sticky-sidebar/ResizeSensor.js",
                  "assets/plugins/theia-sticky-sidebar/theia-sticky-sidebar.js",
                  "assets/js/script.js"
                ];
            
                let isCancelled = false;
            
                const loadScriptsSequentially = async () => {
                  for (const url of scriptUrls) {
                    if (isCancelled) break;
            
                    await new Promise((resolve, reject) => {
                      const script = document.createElement('script');
                      script.src = url;
                      script.async = false;
                      script.onload = () => {
                        console.log(`Loaded: ${url}`);
                        resolve();
                      };
                      script.onerror = () => {
                        console.error(`Failed to load: ${url}`);
                        reject();
                      };
                      document.body.appendChild(script);
                    });
                  }
            
                  // Now init plugins after scripts are loaded
                  if (!isCancelled) {
                    // if (window.AOS) {
                    //   window.AOS.init();
                    // }
            
                    if (window.$ && typeof window.$.fn.datetimepicker === 'function') {
                      window.$('.datetimepicker').datetimepicker();
                    }
            
                    if (typeof window.initBackToTop === 'function') {
                      window.initBackToTop(); // assuming your backToTop script defines this
                    }
            
                    console.log('All scripts loaded and initialized.');
                  }
                };
            
                loadScriptsSequentially();
            
                return () => {
                  isCancelled = true;
                };
              }, []);
    return(
        <>
       {/* Invoices */}
<div className="col-lg-8 col-xl-9">
  <div className="dashboard-header">
    <h3>Invoices</h3>
  </div>
  <div className="search-header">
    <div className="search-field">
      <input type="text" className="form-control" placeholder="Search" />
      <span className="search-icon"><i className="fa-solid fa-magnifying-glass" /></span>
    </div>
  </div>
  <div className="custom-table">
    <div className="table-responsive">
      <table className="table table-center mb-0">
        <thead>
          <tr>
            <th>ID</th>
            <th>Patient</th>
            <th>Appointment Date</th>
            <th>Booked on</th>
            <th>Amount</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{/* <a> */}<button  className="text-blue-600" data-bs-toggle="modal" data-bs-target="#invoice_view">#Inv-2021</button></td>
            <td>
              <h2 className="table-avatar">
                <a href="/" className="avatar avatar-sm me-2">
                  <img className="avatar-img rounded-3" src="assets/img/doctors/doctor-thumb-02.jpg" alt="User" />
                </a>
                <a href="/">Edalin Hendry</a>
              </h2>
            </td>
            <td>24 Mar 2024</td>
            <td>21 Mar 2024</td>
            <td>$300</td>
            <td>
              <div className="action-item">
                {/* <a> */}<button  data-bs-toggle="modal" data-bs-target="#invoice_view">
                  <i className="isax isax-link-2" />
                </button>
                {/* <a> */}<button >
                  <i className="isax isax-printer5" />
                </button>
              </div>
            </td>
          </tr>
          <tr>
            <td>{/* <a> */}<button  className="text-blue-600" data-bs-toggle="modal" data-bs-target="#invoice_view">#Inv-2021</button></td>
            <td>
              <h2 className="table-avatar">
                <a href="/" className="avatar avatar-sm me-2">
                  <img className="avatar-img rounded-3" src="assets/img/doctors/doctor-thumb-05.jpg" alt="User" />
                </a>
                <a href="/">John Homes</a>
              </h2>
            </td>
            <td>17 Mar 2024</td>
            <td>14 Mar 2024</td>
            <td>$450</td>
            <td>
              <div className="action-item">
                {/* <a> */}<button  data-bs-toggle="modal" data-bs-target="#invoice_view">
                  <i className="isax isax-link-2" />
                </button>
                {/* <a> */}<button >
                  <i className="isax isax-printer5" />
                </button>
              </div>
            </td>
          </tr>
          <tr>
            <td>{/* <a> */}<button  className="text-blue-600" data-bs-toggle="modal" data-bs-target="#invoice_view">#Inv-2021</button></td>
            <td>
              <h2 className="table-avatar">
                <a href="/" className="avatar avatar-sm me-2">
                  <img className="avatar-img rounded-3" src="assets/img/doctors/doctor-thumb-03.jpg" alt="User" />
                </a>
                <a href="/">Shanta Neill</a>
              </h2>
            </td>
            <td>11 Mar 2024</td>
            <td>07 Mar 2024</td>
            <td>$250</td>
            <td>
              <div className="action-item">
                {/* <a> */}<button  data-bs-toggle="modal" data-bs-target="#invoice_view">
                  <i className="isax isax-link-2" />
                </button>
                {/* <a> */}<button>
                  <i className="isax isax-printer5" />
                </button>
              </div>
            </td>
          </tr>
          <tr>
            <td>{/* <a> */}<button  className="text-blue-600" data-bs-toggle="modal" data-bs-target="#invoice_view">#Inv-2021</button></td>
            <td>
              <h2 className="table-avatar">
                <a href="/" className="avatar avatar-sm me-2">
                  <img className="avatar-img rounded-3" src="assets/img/doctors/doctor-thumb-08.jpg" alt="User" />
                </a>
                <a href="/">Anthony Tran</a>
              </h2>
            </td>
            <td>26 Feb 2024</td>
            <td>23 Feb 2024</td>
            <td>$320</td>
            <td>
              <div className="action-item">
                {/* <a> */}<button  data-bs-toggle="modal" data-bs-target="#invoice_view">
                  <i className="isax isax-link-2" />
                </button>
                {/* <a> */}<button >
                  <i className="isax isax-printer5" />
                </button>
              </div>
            </td>
          </tr>
          <tr>
            <td>{/* <a> */}<button  className="text-blue-600" data-bs-toggle="modal" data-bs-target="#invoice_view">#Inv-2021</button></td>
            <td>
              <h2 className="table-avatar">
                <a href="/" className="avatar avatar-sm me-2">
                  <img className="avatar-img rounded-3" src="assets/img/doctors/doctor-thumb-01.jpg" alt="User" />
                </a>
                <a href="/">Susan Lingo</a>
              </h2>
            </td>
            <td>18 Feb 2024</td>
            <td>15 Feb 2024</td>
            <td>$480</td>
            <td>
              <div className="action-item">
                {/* <a> */}<button  data-bs-toggle="modal" data-bs-target="#invoice_view">
                  <i className="isax isax-link-2" />
                </button>
                {/* <a> */}<button >
                  <i className="isax isax-printer5" />
                </button>
              </div>
            </td>
          </tr>
          <tr>
            <td>{/* <a> */}<button  className="text-blue-600" data-bs-toggle="modal" data-bs-target="#invoice_view">#IApt123</button></td>
            <td>
              <h2 className="table-avatar">
                <a href="/" className="avatar avatar-sm me-2">
                  <img className="avatar-img rounded-3" src="assets/img/doctors/doctor-thumb-09.jpg" alt="User" />
                </a>
                <a href="/">Joseph Boyd</a>
              </h2>
            </td>
            <td>10 Feb 2024</td>
            <td>07 Feb 2024</td>
            <td>$260</td>
            <td>
              <div className="action-item">
                {/* <a> */}<button  data-bs-toggle="modal" data-bs-target="#invoice_view">
                  <i className="isax isax-link-2" />
                </button>
                {/* <a> */}<button >
                  <i className="isax isax-printer5" />
                </button>
              </div>
            </td>
          </tr>
          <tr>
            <td>{/* <a> */}<button  className="text-blue-600" data-bs-toggle="modal" data-bs-target="#invoice_view">#Inv-2021</button></td>
            <td>
              <h2 className="table-avatar">
                <a href="/" className="avatar avatar-sm me-2">
                  <img className="avatar-img rounded-3" src="assets/img/doctors/doctor-thumb-07.jpg" alt="User" />
                </a>
                <a href="/">Juliet Gabriel</a>
              </h2>
            </td>
            <td>28 Jan 2024</td>
            <td>25 Jan 2024</td>
            <td>$350</td>
            <td>
              <div className="action-item">
                {/* <a> */}<button  data-bs-toggle="modal" data-bs-target="#invoice_view">
                  <i className="isax isax-link-2" />
                </button>
                {/* <a> */}<button >
                  <i className="isax isax-printer5" />
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  {/* Pagination */}
  <div className="pagination dashboard-pagination">
    <ul>
      <li>
        {/* <a> */}
        <button className="page-link"><i className="fa-solid fa-chevron-left" /></button>
      </li>
      <li>
        {/* <a> */}
        <button className="page-link">1</button>
      </li>
      <li>
        {/* <a> */}
        <button className="page-link active">2</button>
      </li>
      <li>
        {/* <a> */}
        <button className="page-link">3</button>
      </li>
      <li>
        {/* <a> */}
        <button className="page-link">4</button>
      </li>
      <li>
        {/* <a> */}
        <button className="page-link">...</button>
      </li>
      <li>
        {/* <a> */}
        <button className="page-link"><i className="fa-solid fa-chevron-right" /></button>
      </li>
    </ul>
  </div>
  {/* /Pagination */}
</div>
{/* /Invoices */}
{/*View Invoice */}
<div className="modal fade custom-modals" id="invoice_view">
  <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div className="modal-content">
      <div className="modal-header">
        <h3 className="modal-title">View Invoice</h3>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <i className="fa-solid fa-xmark" />
        </button>
      </div>				
      <div className="modal-body pb-0">
        <div className="prescribe-download">
          <h5>21 Mar  2024</h5>
          <ul>
            <li>{/* <a> */}<button  className="print-link"><i className="isax isax-printer5" /></button></li>
            <li>{/* <a> */}<button className="btn btn-primary prime-btn">Download</button></li>
          </ul>							
        </div>
        <div className="view-prescribe invoice-content">
          <div className="invoice-item">
            <div className="row">
              <div className="col-md-6">
                <div className="invoice-logo">
                  <img src="assets/img/logo.png" alt="logo" />
                </div>
              </div>
              <div className="col-md-6">
                <p className="invoice-details">
                  <strong>Invoice No : </strong> #INV005<br />
                  <strong>Issued:</strong> 21 Mar 2024
                </p>
              </div>
            </div>
          </div>
          {/* Invoice Item */}
          <div className="invoice-item">
            <div className="row">
              <div className="col-md-4">
                <div className="invoice-info">
                  <h6 className="customer-text">Billing From</h6>
                  <p className="invoice-details invoice-details-two">
                    Edalin Hendry <br />
                    806 Twin Willow Lane, <br />
                    Newyork, USA <br />
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="invoice-info">
                  <h6 className="customer-text">Billing To</h6>
                  <p className="invoice-details invoice-details-two">
                    Richard Wilson <br />
                    299 Star Trek Drive<br />
                    Florida, 32405, USA<br />
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="invoice-info invoice-info2">
                  <h6 className="customer-text">Payment Method</h6>
                  <p className="invoice-details">
                    Debit Card <br />
                    XXXXXXXXXXXX-2541<br />
                    HDFC Bank<br />
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* /Invoice Item */}
          {/* Invoice Item */}
          <div className="invoice-item invoice-table-wrap">
            <div className="row">
              <div className="col-md-12">
                <h6>Invoice Details</h6>
                <div className="table-responsive">
                  <table className="invoice-table table table-bordered">
                    <thead>
                      <tr>
                        <th>Description</th>
                        <th>Quatity</th>
                        <th>VAT</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>General Consultation</td>
                        <td>1</td>
                        <td>$0</td>
                        <td>$150</td>
                      </tr>
                      <tr>
                        <td>Video Call</td>
                        <td>1</td>
                        <td>$0</td>
                        <td>$100</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="col-md-6 col-xl-4 ms-auto">
                <div className="table-responsive">
                  <table className="invoice-table-two table">
                    <tbody>
                      <tr>
                        <th>Subtotal:</th>
                        <td><span>$350</span></td>
                      </tr>
                      <tr>
                        <th>Discount:</th>
                        <td><span>-10%</span></td>
                      </tr>
                      <tr>
                        <th>Total Amount:</th>
                        <td><span>$315</span></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          {/* /Invoice Item */}
          {/* Invoice Information */}
          <div className="other-info mb-0">
            <h4>Other information</h4>
            <p className="mb-0">An account of the present illness, which includes the circumstances surrounding the onset of recent health changes and the chronology of subsequent events that have led the patient to seek medicine</p>
          </div>
          {/* /Invoice Information */}
        </div>	
      </div>
    </div>
  </div>
</div>
{/* /View Invoice */}


        </>
    );
}
export default Invoices;